import Vue from 'vue'
import Router from 'vue-router'
import routes from 'vue-auto-routing'
import { createRouterLayout } from 'vue-router-layout'

Vue.use(Router)

const RouterLayout = createRouterLayout(layout => {
    return import('@/layouts/' + layout + '.vue')
})

export default new Router({
    // 1. Mantenemos el modo history de forma limpia
    mode: 'history',

    // 2. Definimos la base usando la variable de entorno oficial de Vue CLI
    // Esto soluciona de ra�z el extrav�o de rutas tras la reescritura de IIS
    base: process.env.BASE_URL || '/',

    routes: [
        {
            path: '/',
            component: RouterLayout,
            children: routes
        },
        // 3. Control de rutas no encontradas (Fallback preventivo)
        // Si una ruta falla en producci�n, redirige de forma controlada en lugar de romper la pantalla
        {
            path: '*',
            redirect: '/'
        }
    ]
})
